/**
 * Created by akrio on 2018/3/23.
 */
import { REPOST_HISTORY } from "../mutation-types";

export default {
  state: {
    repostHistoryList: [],
  },
  mutations: {
    [REPOST_HISTORY](state, repostHistoryList) {
      state.repostHistoryList = repostHistoryList;
    },
  },
  getters: {
    [REPOST_HISTORY](state) {
      return state.repostHistoryList;
    },
  },
};
